// extracted by mini-css-extract-plugin
export default {"container":"pageLink_container__iDnDv","active":"pageLink_active__vnLd2","icon":"pageLink_icon__vNXpQ"};